import * as React from "react";
import { forwardRef } from "react";
const SvgReport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M15 19.0146H22",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15 25.0146H22",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11 18.5146C11.2761 18.5146 11.5 18.7385 11.5 19.0146C11.5 19.2908 11.2761 19.5146 11 19.5146C10.7239 19.5146 10.5 19.2908 10.5 19.0146C10.5 18.7385 10.7239 18.5146 11 18.5146",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15 13.0146H22",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11 12.5146C11.2761 12.5146 11.5 12.7385 11.5 13.0146C11.5 13.2908 11.2761 13.5146 11 13.5146C10.7239 13.5146 10.5 13.2908 10.5 13.0146C10.5 12.7385 10.7239 12.5146 11 12.5146",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M11 24.5146C11.2761 24.5146 11.5 24.7385 11.5 25.0146C11.5 25.2908 11.2761 25.5146 11 25.5146C10.7239 25.5146 10.5 25.2908 10.5 25.0146C10.5 24.7385 10.7239 24.5146 11 24.5146",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M21 6.01465H26C27.1046 6.01465 28 6.91008 28 8.01465V29.0146C28 30.1192 27.1046 31.0146 26 31.0146H6C4.89543 31.0146 4 30.1192 4 29.0146V8.01465C4 6.91008 4.89543 6.01465 6 6.01465H11C11 3.25322 13.2386 1.01465 16 1.01465C18.7614 1.01465 21 3.25322 21 6.01465Z",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M16 5.01465C16.2761 5.01465 16.5 5.23851 16.5 5.51465C16.5 5.79079 16.2761 6.01465 16 6.01465C15.7239 6.01465 15.5 5.79079 15.5 5.51465C15.5 5.23851 15.7239 5.01465 16 5.01465",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgReport);
export default ForwardRef;
